import i18n from '@/utils/i18n';
import React from 'react';
import { ForceUpgradeContent } from './force-upgrade-content';
import { partnerSupplier } from '@/utils/environment';
import { useUniversalAppLink } from '@/hooks/use-universal-app-link';

export const AppStoreUpgradeScreen: React.FC = () => {
  const { loading, onPressLink } = useUniversalAppLink();

  return (
    <ForceUpgradeContent
      buttonProps={{
        children: i18n.t('update'),
        loading,
        loadingProps: {
          testID: 'loading-indicator',
        },
        onPress: onPressLink,
        trackingData: {
          name: 'unsupported_screen.update_button',
          properties: {
            businessOrganizationUUID: partnerSupplier.businessOrganizationUUID,
          },
        },
      }}
      footerText={i18n.t('unsupported_version_info')}
      subtitle={i18n.t('unsupported_version_subtitle')}
      title={i18n.t('unsupported_version_title')}
    />
  );
};
